module.exports = __webpack_public_path__ + "static/verman-3909c877de186b6fe6f8c853f17ebe44.png";